<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="Figma" class="d-icon d-icon--figma" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12.333 12a3.666 3.666 0 1 1 7.333 0 3.666 3.666 0 0 1-7.333 0Z" fill="#1ABCFE"/><path d="M5 19.333a3.667 3.667 0 0 1 3.667-3.666h3.666v3.666a3.667 3.667 0 1 1-7.333 0Z" fill="#0ACF83"/><path d="M12.333 1v7.333H16A3.667 3.667 0 0 0 16 1h-3.667Z" fill="#FF7262"/><path d="M5 4.667a3.667 3.667 0 0 0 3.667 3.666h3.666V1H8.667A3.667 3.667 0 0 0 5 4.667Z" fill="#F24E1E"/><path d="M5 12a3.666 3.666 0 0 0 3.667 3.667h3.666V8.333H8.667A3.667 3.667 0 0 0 5 12Z" fill="#A259FF"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFigma',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
